module.exports = __webpack_public_path__ + "static/media/23import-50.526083b6.xlsx";